export default class InfoHEROSE_NA{
    constructor(_wrapper: HTMLElement) {
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        _parent.classList.add('footer-info-naeu');
        _parent.innerHTML= `
        <div class="footer-rating">
            <img src="https://assets.playnccdn.com/resource/heroes/footer-rating-esrb.png">
        </div>
        `;
    }
}
